import * as React from 'react';
import FailureSnackbar from './FailureSnackbar';
import InfoSnackbar from './InfoSnackbar';
import SuccessSnackbar from './SuccessSnackbar';
import WarningSnackbar from './WarningSnackbar';
import {
    currentNotifications,
    dismissNotification,
    Notification,
    subscribeToNotifications
} from './notifications';

const snackbarFor = {
    success: SuccessSnackbar,
    failure: FailureSnackbar,
    warning: WarningSnackbar,
    info: InfoSnackbar
};

type NotificationsHostState = {
    notifications: Notification[];
};

class NotificationsHost extends React.Component<{}, NotificationsHostState> {
    state: NotificationsHostState = { notifications: currentNotifications() };

    private unsubscribe: () => void = () => undefined;

    componentDidMount() {
        this.unsubscribe = subscribeToNotifications((notifications) =>
            this.setState({ notifications })
        );
    }

    componentWillUnmount() {
        this.unsubscribe();
    }

    render() {
        return (
            <>
                {this.state.notifications.map((notification, index) => {
                    const NotificationSnackbar = snackbarFor[notification.severity];
                    return (
                        <NotificationSnackbar
                            key={notification.id}
                            open
                            onClose={() => dismissNotification(notification.id)}
                            text={notification.text}
                            stackIndex={index}
                        />
                    );
                })}
            </>
        );
    }
}

export default NotificationsHost;
